'use client';

import { useEffect, ReactNode } from 'react';

import smoothScroll from '@/shared/utils/smoothScroll';

interface SearchScrollTemplateProps {
  children: ReactNode;
}

export default function SearchScrollTemplate({
  children,
}: SearchScrollTemplateProps) {
  useEffect(() => {
    const targetId = window.localStorage.getItem('searchTargetId');

    if (targetId && document.getElementById(targetId)) {
      window.localStorage.removeItem('searchTargetId');
      smoothScroll(targetId, 'center');
    }
  }, []);

  return <>{children}</>;
}
